<template lang="pug">
div.panel-header
  div.header.text-center
    h2.title Airdropper
    p.category
      | Airdrop tokens in bulk to a list of wallet addresses in seconds and for cheap!
</template>

<script>
export default {};
</script>

<style scoped>
.category {
  text-transform: inherit;
}
</style>
